import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      height: '100%',
      backgroundColor: '#ffffff',
      borderRadius: '4px',
    },
  },
  {
    name: 'Blank',
  },
);
